import React, { useEffect, useRef } from 'react';
import styles from '../../components/me/Me.module.css';
import natalie from "../../images/נטלי שוורץ תמונה ראשית.webp";

const AboutMe = () => {
  const containerRef = useRef(null);

  const handleButtonClick = () => {
    const phoneNumber = "+972508727802";
    const message = "היי נטלי, הגעתי מהדף שלך, אשמח לשמוע עוד על...";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.2 }
    );

    const revealElements = containerRef.current.querySelectorAll(`.${styles.revealItem}`);
    revealElements.forEach(el => {
      el.style.opacity = "0";
      el.style.transform = "translateY(20px)";
      el.style.transition = "opacity 1s ease, transform 1s ease";
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={containerRef} className={styles.section} id="מי-אני">
      <div className={styles.container}>
        <div className={`${styles.imageWrapper} ${styles.revealItem}`}>
          <img src={natalie} alt="נטלי שוורץ" className={styles.image} />
        </div>

        <div className={`${styles.content} ${styles.revealItem}`}>
          <h2 className={styles.mainTitle}>הגיע הזמן שנכיר!</h2>
          <div className={styles.subtitle}>אז אני נטלי, ורגע לפני שנכנסים לעניינים, קחי קצת ממני כי בשביל זה הדף הזה קיים, לא ;)</div>

          <div className={styles.textBlock}>
            <p className={styles.paragraph}>
              אני מנהלת סושיאל ויוצרת תוכן, אבל בתכלס, אני קודם כל אדם של אנשים ושל תהליכים.
              הבידול הוא הסיפור שלך. לא גרסה משוכפלת של אף אחת אחרת, אלא את– באמת.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אם היית אומרת לי לפני כמה שנים שזה יהיה המקצוע שלי, הייתי אומרת לך "מה פתאום!!!". הילדה המופנמת שלא עוברת מסך? אני?
              אבל החיים גלגלו אותי בדרך מלאה בניסיונות וטעויות, עד שהבנתי שאני לא מחפשת רק עבודה, אני מחפשת משמעות. אין כיף כזה מלקחת את התחביב שאני כל כך אוהבת, עריכה וצילום, ולהפוך אותו למקצוע שאני קמה בשבילו עם אש בעיניים בכל בוקר.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אני לא מאמינה בתבניות, כי כל עסק הוא עולם וכל בעלת עסק היא יחידה במינה. מה שלמדתי בדרך זה ששיווק שעובד באמת חייב לבוא מאותנטיות. לפעמים תשמעי ממני "זה לא מתאים לעסק שלך", לא כי אני נגדך, אלא כי אני שומרת על הדיוק שלך.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.finalText}>
              התהליך השיווקי איתי הוא חוויה, עם אנרגיות טובות, התרגשות וקצת אומץ לצאת מהשגרה. מעל הכל חשוב לי שנעבוד בשיתוף פעולה אמיתי, ותבואי פתוחים לתהליך. אני מתחייבת ליצור אווירה כמה שיותר טובה כדי שייצא לנו תוכן פגז ויהיו לך עמודים שמעבירים את הלקוחות שלך מסע חימום מדוייק עד השיחה איתך!
            </p>
          </div>

          <button className={styles.ctaButton} onClick={handleButtonClick}>
            <span className={styles.buttonIcon}>💬</span>
            הדרך שלנו ביחד מתחילה כאן
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
